import AvatarPage from "../../../../avatar-page";
import { replaceParagraph } from "../../../../SlateEditor/constant/Helper";

const Text = (props) => {
   const { card } = props;
   const { buttons } = card;
   return (
      <div className="row-wrapper">
         <div className="">
            <AvatarPage />
         </div>
         <div className="row-wrapper__children">
            <div className="card-text">
               <div className="card-text__content">
                  <span>
                     {replaceParagraph(card.title)}
                  </span>
               </div>
               <div className="card-text__button">
                  <div className="card__btn-container">
                     {buttons && buttons.length > 0 && buttons.map((button, index) => (
                        <p key={index}>{button.title}</p>
                     ))}
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}


export default Text;